import React from 'react'
import PropTypes from 'prop-types'
import t from '../../i18n/translations/translations'
import BackArrowSvg from './BackArrowSvg'
import './BackButton.css'

function BackButton({ lang, typeBack, returnUrl, className }) {
  const handleGoBack = () => {
    if (returnUrl) {
      window.location.href = returnUrl
      return
    }

    if (typeBack === 'typeBackFromFacility') {
      window.location.reload(false)
      return
    }

    if (window.history.length > 1) {
      window.history.back()
    } else {
      window.location.href = '/'
    }
  }

  const normalizedLang = (lang || 'es').trim().toLowerCase()
  const label = t.go_back[normalizedLang] || t.go_back.es
  const btnClass = `cta ${className || ''}`.trim()

  return (
    <div className="wrapper">
      <button
        className={btnClass}
        onClick={handleGoBack}
        type="button"
        aria-label={label}
      >
        <span>{label}</span>
        <span className="cta__icon">
          <BackArrowSvg />
        </span>
      </button>
    </div>
  )
}

BackButton.propTypes = {
  lang: PropTypes.string.isRequired,
  typeBack: PropTypes.string,
  returnUrl: PropTypes.string,
  className: PropTypes.string,
}

BackButton.defaultProps = {
  typeBack: '',
  returnUrl: null,
  className: '',
}

export default BackButton